import { render, staticRenderFns } from "./FarmWorkRecordItem.vue?vue&type=template&id=041fbea0&scoped=true&"
import script from "./FarmWorkRecordItem.vue?vue&type=script&lang=js&"
export * from "./FarmWorkRecordItem.vue?vue&type=script&lang=js&"
import style0 from "./FarmWorkRecordItem.vue?vue&type=style&index=0&id=041fbea0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041fbea0",
  null
  
)

export default component.exports